import {
  NaceCodeEntity,
  NaceCodeGeoAggregateAttributeEntity,
  NaceCodeGeoAggregateMeasureEntity,
} from '@nk/data-entities-lib';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { EntityUpdateTimestampService } from '@nk/core/services/entity-update-timestamp.service';
import { StableCache } from '@nk/caching-lib';
import { AnalysisApiClientAccess } from '@nk/access-block';

@Injectable()
export class NaceCodeService {
  constructor(
    private _analysisApi: AnalysisApiClientAccess,
    private _entityUpdateTimestampService: EntityUpdateTimestampService,
  ) {}

  public naceCodeListCache = new StableCache(
    'app.nace_code',
    this,
    this.fetchNaceCodeList,
    this._entityUpdateTimestampService.timestamps$,
  );
  public fetchNaceCodeList(level?: string, naceCodeSchemas?: string): Observable<NaceCodeEntity[]> {
    let params = new HttpParams();
    if (level) {
      params = params.append('hierarchy_level', level);
    }
    if (naceCodeSchemas) {
      params = params.append('nace_code_schemas', naceCodeSchemas);
    }
    return this._analysisApi.get<NaceCodeEntity[]>('/nace-code', { params: params });
  }

  // TODO: stable cache?
  public fetchNaceCodeGeoAggregateAttribute(): Observable<NaceCodeGeoAggregateAttributeEntity[]> {
    return this._analysisApi.get<NaceCodeGeoAggregateAttributeEntity[]>('/nace-code-geo-aggregate-attribute');
  }

  public fetchNaceCodeGeoAggregateMeasureByGeoAggregateAttribute(
    naceCodeGeoAggregateAttributeUuid: string,
    hierarchyLevel = 1,
    latestFlag = false,
  ): Observable<NaceCodeGeoAggregateMeasureEntity[]> {
    let params = new HttpParams();
    params = params.append('hierarchy_level', String(hierarchyLevel));
    params = params.append('latest_flag', String(latestFlag));

    return this._analysisApi.get<NaceCodeGeoAggregateMeasureEntity[]>(
      `/nace-code-geo-aggregate-attribute/${naceCodeGeoAggregateAttributeUuid}/nace-code-geo-aggregate-measure`,
      { params },
    );
  }
}
